import { render, staticRenderFns } from "./NuveiCardForm.vue?vue&type=template&id=5d178910&scoped=true&"
import script from "./NuveiCardForm.vue?vue&type=script&lang=js&"
export * from "./NuveiCardForm.vue?vue&type=script&lang=js&"
import style0 from "./NuveiCardForm.vue?vue&type=style&index=0&id=5d178910&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d178910",
  null
  
)

export default component.exports